<template>
  <div class="c-live-system-setting">
    <!-- 系统设置 -->
    <div class="c-live-system-setting__title">
      <span>{{ label }}</span>
      <div class="plv-ml-12">
        <el-checkbox
          v-model="checkAll"
          :indeterminate="isIndeterminate"
          @change="handleCheckAllChange"
        >
          全选
        </el-checkbox>
      </div>
    </div>
    <plv-checkbox-group
      v-model="checkedSettings"
      :checkboxs="systemSettings"
    />
  </div>
</template>

<script>
import accountInfoMixin from '@/mixins/accountInfo';

export default {
  name: 'LiveSystemSetting',

  mixins: [accountInfoMixin],

  props: {
    label: {
      type: String,
      default: '系统设置'
    },
  },

  data() {
    return {
      checkAll: false,
      isIndeterminate: true,
      checkedSettings: [],
    };
  },

  computed: {
    // eslint-disable-next-line sonarjs/cognitive-complexity
    systemSettings() {
      const systemBaseSettings = [
        {
          label: '云分发',
          value: 'distributeModifyEnabled',
          disabled: !this.ynToBool(this.liveInfo.ditributeEnabled),
        },
        {
          label: '课件重制',
          value: 'pptRecordEnabled',
          disabled: true,
        },
        {
          label: '美颜',
          value: 'beautyEnabled',
          disabled: !this.ynToBool(this.liveInfo.beautyEnabled ?? 'N'),
        },
        {
          label: 'AI扣像',
          value: 'aiVirtualBgEnabled',
          disabled: !this.ynToBool(this.liveInfo.aiVirtualBgEnabled ?? 'N'),
        },
        {
          label: 'MP4裁剪',
          value: 'recordMp4Enabled',
          disabled: !this.ynToBool(this.overViewInfo.recordMp4Enabled ?? 'N')
        },
        {
          label: '问卷',
          value: 'questionnaireEnabled',
          disabled: !this.ynToBool(this.overViewInfo.questionnaireEnabled ?? 'N')
        },
        {
          label: '抽奖',
          value: 'lotteryEnabled',
          disabled: !this.ynToBool(this.overViewInfo.lotteryEnabled ?? 'N')
        },
        {
          label: '分享',
          value: 'shareEnabled',
          disabled: !this.ynToBool(this.overViewInfo.shareEnabled ?? 'N')
        },
        {
          label: '平台更新动态',
          value: 'platformUpdatesEnabled',
        },
        {
          label: '概览页',
          value: 'overviewPageEnabled',
        }
      ];
      // 获取概览数据
      const userChildrenEnabled = this.overViewInfo.userChildrenEnabled || 'N';
      const chatUserStatusCallbackEnabled = this.overViewInfo.chatUserStatusCallbackEnabled || 'N';
      const chatUserListCallbackEnabled = this.overViewInfo.chatUserListCallbackEnabled || 'N';
      if (this.ynToBool(userChildrenEnabled)) {
        systemBaseSettings.push({
          label: '直播间子账号',
          value: 'userChildrenEnabled',
        });
      }
      if (this.ynToBool(chatUserStatusCallbackEnabled)) {
        systemBaseSettings.push({
          label: '直播间人员状态回调',
          value: 'chatUserStatusCallbackEnabled',
        });
      }
      if (this.ynToBool(chatUserListCallbackEnabled)) {
        systemBaseSettings.push({
          label: '直播间人员列表数据回调',
          value: 'chatUserListCallbackEnabled',
          disabled: !this.ynToBool(chatUserStatusCallbackEnabled) || !this.checkedSettings.includes('chatUserStatusCallbackEnabled'), // 人员状态回调没开启，那么置灰
        });
      }
      systemBaseSettings.push({
        label: '无延迟直播',
        value: 'pureRtcEnabled',
        disabled: !this.isPureRtcEnabled
      });
      if (this.ynToBool(this.liveInfo.pptAnimationEnabled ?? 'N')) {
        systemBaseSettings.push({
          label: 'PPT动效转码',
          value: 'pptAnimationEnabled',
        });
      }

      return systemBaseSettings;
    },
    allEnabledOptionValues() {
      return this.systemSettings.filter(i => !i.disabled).map(i => i.value);
    }
  },

  watch: {
    checkedSettings() {
      if (!this.checkedSettings.includes('chatUserStatusCallbackEnabled')) {
        const chatUserListCallbackIndex = this.checkedSettings.indexOf('chatUserListCallbackEnabled');
        if (chatUserListCallbackIndex !== -1) {
          this.checkedSettings.splice(chatUserListCallbackIndex, 1);
        }
      }

      const checkedCount = this.checkedSettings.length;
      this.checkAll = checkedCount === this.allEnabledOptionValues.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.allEnabledOptionValues.length;
    }
  },

  methods: {
    handleCheckAllChange(val) {
      this.checkedSettings = val ? this.allEnabledOptionValues : [];
      this.isIndeterminate = false;
    },
    $setSettings(settings) {
      this.checkedSettings = settings;
    },
    $getSettings() {
      const result = {};
      this.systemSettings.forEach((setting) => {
        if (this.checkedSettings.includes(setting.value)) {
          result[setting.value] = 'Y';
        } else {
          result[setting.value] = 'N';
        }
      });
      return result;
    }
  }
};
</script>

<style lang="scss" >
.c-live-system-setting {
  .plv-checkbox-group {
    .plv-checkbox {
      margin-bottom: 12px;
    }
  }
}

.c-live-system-setting__title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 20px;
  margin-top: 18px;

  display: flex;
  align-items: center;
  gap: 12px;

  .el-checkbox {
    line-height: 22px;
  }
  .el-checkbox__inner {
    width: 16px;
    height: 16px;
  }
}
</style>
